<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValue" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id" 
      placeholder="Región" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-bind:[tooltipDirective]="tooltip" 
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Number,
      default: null
    }
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValue = ref(6); // Selecciona por defecto la región con Id 6

    const fetchOptions = () => {
      // Solo agrega la región con Id 6 y Glosa "Valparaíso"
      options.value = [
        { Id: 6, Glosa: 'Valparaíso' }
      ];
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValue.value);
    };

    onMounted(() => {
      fetchOptions(); // Cargar las opciones al montar el componente
    });

    return {
      options,
      selectedValue,
      emitSelection
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>